export default __webpack_public_path__ + "static/media/Title_Icon.266e61d8.svg";